import { render } from "./card-view.vue?vue&type=template&id=ee482474&scoped=true"
import script from "./card-view.vue?vue&type=script&lang=js"
export * from "./card-view.vue?vue&type=script&lang=js"

import "./card-view.vue?vue&type=style&index=0&id=ee482474&lang=scss"
import "./card-view.vue?vue&type=style&index=1&id=ee482474&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./card-view.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee482474"]])

export default __exports__